// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2YXNP","label":"Section_label__4EZbf","contentWrap":"Section_contentWrap__Xi_GH","footer":"Section_footer__3amUj","footerInner":"Section_footerInner__36UP0"};